export const breakdownTypes = [
    { key: "region", value: "Region" },
    { key: "license", value: "License" },
    { key: "location", value: "Location" },
    { key: "fullName", value: "Partner" },
    { key: "assignmentId", value: "Assignment" },
    { key: "company", value: "Company" },
    { key: "parent", value: "Parent" },
    { key: "function", value: "Function" },
    { key: "industry", value: "Industry" },
    { key: "reportGroup", value: "Report Group" },
    { key: "practiceGroup", value: "Practice Group" },
    { key: "subsector", value: "Subsector" },
    { key: "industryGroup", value: "Industry Group" },
    { key: "sector", value: "Sector" },
    { key: "capability", value: "Capability" }
];
const getGroupId = (group) => {
    return group?.id ?? group?.ID;
};
const getGroupType = (group, reportGroups, dashboard = false) => {
    const mapped = reportGroups[getGroupId(group)];
    if (dashboard && (mapped?.Type || mapped?.type))
        return (mapped.Type || mapped.type).toString();
    return (group?.Type || group?.type || mapped?.Type || mapped?.type || "").toString();
};
const isGroupType = (group, reportGroups, dashboard, ...types) => {
    const type = getGroupType(group, reportGroups, dashboard).toLowerCase();
    return types.some((candidate) => candidate.toLowerCase() === type);
};
const getGroupName = (group, reportGroups) => {
    const mapped = reportGroups[getGroupId(group)];
    return mapped?.Name || mapped?.name || group?.Name || group?.name;
};
export const filterBreakdownResults = (results, breakdown, groups, view) => {
    const reportGroups = groups.reduce((acc, curr) => {
        acc[curr.ID] = curr;
        return acc;
    }, {});
    const name = view || breakdown.breakdown;
    let filteredResults = results || [];
    if (!view && breakdown.breakdownFilter) {
        if (["reportGroup", "practiceGroup", "subsector", "industryGroup", "sector", "capability"].some((x) => name === x)) {
            filteredResults = filteredResults.filter((row) => row.reportGroups.some((group) => getGroupName(group, reportGroups) == breakdown.breakdownFilter));
        }
        else {
            filteredResults = filteredResults.filter((row) => row[name] == breakdown.breakdownFilter);
        }
    }
    return filteredResults;
};
export const createBreakdownMetrics = (filteredResults, context) => {
    const { breakdown, reportGroups: groups, financial: $financial, options, dashboard = false, groupFilters = [] } = context;
    const hasOptions = !!options;
    const reportGroups = groups.reduce((acc, curr) => {
        acc[curr.ID] = curr;
        return acc;
    }, {});
    const name = options?.view || breakdown.breakdown;
    const selectedGroups = new Set((dashboard ? groupFilters : []).filter(filter => filter.key?.Id === "Groups" && filter.value?.Id != null)
        .map(filter => String(filter.value.Id)));
    const matchesSectorFilter = group => selectedGroups.size === 0
        || selectedGroups.has(String(getGroupId(group)))
        || selectedGroups.has(String(reportGroups[getGroupId(group)]?.Parent));
    const mapping = {};
    filteredResults.forEach((row) => {
        if (name === "reportGroup") {
            row.reportGroups.forEach((group) => {
                const groupName = getGroupName(group, reportGroups);
                if (!Object.prototype.hasOwnProperty.call(mapping, groupName)) {
                    mapping[groupName] = [row];
                }
                else {
                    mapping[groupName].push(row);
                }
            });
        }
        else if (name === "practiceGroup") {
            row.reportGroups.forEach((group) => {
                if (isGroupType(group, reportGroups, dashboard, "PracticeGroup")) {
                    const groupName = getGroupName(group, reportGroups);
                    if (!Object.prototype.hasOwnProperty.call(mapping, groupName)) {
                        mapping[groupName] = [row];
                    }
                    else {
                        mapping[groupName].push(row);
                    }
                }
            });
        }
        else if (name === "subsector") {
            row.reportGroups.forEach((group) => {
                if (isGroupType(group, reportGroups, dashboard, "Subsector")) {
                    const groupName = getGroupName(group, reportGroups);
                    if (!Object.prototype.hasOwnProperty.call(mapping, groupName)) {
                        mapping[groupName] = [row];
                    }
                    else {
                        mapping[groupName].push(row);
                    }
                }
            });
        }
        else if (name === "industryGroup") {
            row.reportGroups.forEach((group) => {
                if (isGroupType(group, reportGroups, dashboard, "Industry", "IndustryGroup")) {
                    const groupName = getGroupName(group, reportGroups);
                    if (!Object.prototype.hasOwnProperty.call(mapping, groupName)) {
                        mapping[groupName] = [row];
                    }
                    else {
                        mapping[groupName].push(row);
                    }
                }
            });
        }
        else if (name === "sector") {
            row.reportGroups.forEach((group) => {
                if (isGroupType(group, reportGroups, dashboard, "Sector", "SectorGroup") && matchesSectorFilter(group)) {
                    const groupName = getGroupName(group, reportGroups);
                    if (!Object.prototype.hasOwnProperty.call(mapping, groupName)) {
                        mapping[groupName] = [row];
                    }
                    else {
                        mapping[groupName].push(row);
                    }
                }
            });
        }
        else if (name === "capability") {
            row.reportGroups.forEach((group) => {
                if (isGroupType(group, reportGroups, dashboard, "Capability", "CapabilityGroup")) {
                    const groupName = getGroupName(group, reportGroups);
                    if (!Object.prototype.hasOwnProperty.call(mapping, groupName)) {
                        mapping[groupName] = [row];
                    }
                    else {
                        mapping[groupName].push(row);
                    }
                }
            });
        }
        else {
            if (!Object.prototype.hasOwnProperty.call(mapping, row[name])) {
                mapping[row[name]] = [row];
            }
            else {
                mapping[row[name]].push(row);
            }
        }
    });
    const teamingValue_metric = $financial.getTeamingValue(filteredResults);
    const teamingValue_metric_compare = $financial.compare.getTeamingValue(filteredResults);
    const results = [];
    Object.entries(mapping).forEach((entry) => {
        const key = entry[0];
        const value = entry[1]; //rows
        if (hasOptions && options.compare) {
            const timeToFillSummary = $financial.compare.getTimeToFillSummary(value);
            const filledJobValueSummary = $financial.compare.getFilledJobValueSummary(value);
            results.push({
                name: key,
                companyId: value[0].companyId,
                parentId: value[0].parentId,
                userId: value[0].userId,
                company: value[0].company,
                jobTitle: value[0].jobTitle,
                isKeyAccount: value[0].IsKeyAccount,
                isParentKeyAccount: value[0].ParentIsKeyAccount,
                hasActivePPA: value[0].hasActivePPA ?? value[0].HasActivePPA,
                parentHasActivePPA: value[0].parentHasActivePPA ?? value[0].ParentHasActivePPA,
                totalBillings: $financial.compare.getTotalBillings(value),
                teamingValue: $financial.compare.getTeamingValue(value),
                teamingRevenue: $financial.compare.getTeamingRevenue(value),
                teamingTaken: $financial.compare.getTeamingTaken(value),
                teamingFilled: $financial.compare.getTeamingFilled(value),
                assignmentsTaken: $financial.compare.getAssignmentsTaken(value),
                assignmentsFilled: $financial.compare.getAssignmentsFilled(value),
                timeToFill: timeToFillSummary.totalDays / (timeToFillSummary.count || 1),
                timeToFillTotalDays: timeToFillSummary.totalDays,
                timeToFillCount: timeToFillSummary.count,
                executive: $financial.compare.getExecutive(value),
                consulting: $financial.compare.getConsulting(value),
                im: $financial.compare.getIM(value),
                strategyBillings: $financial.compare.getStrategyBillings(value),
                strategyTaken: $financial.compare.getStrategyTaken(value),
                filledJobValue: filledJobValueSummary.total / (filledJobValueSummary.count || 1),
                filledJobValueTotal: filledJobValueSummary.total,
                filledJobValueCount: filledJobValueSummary.count,
                teamingValue_metric: teamingValue_metric_compare
            });
        }
        else {
            const timeToFillSummary = $financial.getTimeToFillSummary(value);
            const filledJobValueSummary = $financial.getFilledJobValueSummary(value);
            results.push({
                name: key,
                companyId: value[0].companyId,
                parentId: value[0].parentId,
                userId: value[0].userId,
                company: value[0].company,
                jobTitle: value[0].jobTitle,
                isKeyAccount: value[0].IsKeyAccount,
                isParentKeyAccount: value[0].ParentIsKeyAccount,
                hasActivePPA: value[0].hasActivePPA ?? value[0].HasActivePPA,
                parentHasActivePPA: value[0].parentHasActivePPA ?? value[0].ParentHasActivePPA,
                totalBillings: $financial.getTotalBillings(value),
                teamingValue: $financial.getTeamingValue(value),
                teamingRevenue: $financial.getTeamingRevenue(value),
                teamingTaken: $financial.getTeamingTaken(value),
                teamingFilled: $financial.getTeamingFilled(value),
                assignmentsTaken: $financial.getAssignmentsTaken(value),
                assignmentsFilled: $financial.getAssignmentsFilled(value),
                timeToFill: timeToFillSummary.totalDays / (timeToFillSummary.count || 1),
                timeToFillTotalDays: timeToFillSummary.totalDays,
                timeToFillCount: timeToFillSummary.count,
                executive: $financial.getExecutive(value),
                consulting: $financial.getConsulting(value),
                im: $financial.getIM(value),
                strategyBillings: $financial.getStrategyBillings(value),
                strategyTaken: $financial.getStrategyTaken(value),
                filledJobValue: filledJobValueSummary.total / (filledJobValueSummary.count || 1),
                filledJobValueTotal: filledJobValueSummary.total,
                filledJobValueCount: filledJobValueSummary.count,
                teamingValue_metric: teamingValue_metric
            });
        }
    });
    return results;
};
